module.exports = __webpack_public_path__ + "static/media/bphl.e7925ec4.webp";